import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import { TextBox } from "../core/components/textBox";
import { Dialog, DialogAction } from "../core/components/dialog";
import { ComponentHelper } from "../core/util/componentHelper";
import { Config } from "../core/config/config";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class EditMobileUserSettings extends React.Component<EditMobileUserSettingsProps, EditMobileUserSettingsState> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;
    private dialogActions: Array<DialogAction> = [];
    textBoxValue = null;
    factory = ComponentHelper.createFactory();
    constructor(props) {
        super(props);
        this.common.init(this);
        this.dialogActions = [{ label: Config.translations.ok, action: this.cloeseDialoge }]
        this.state = { showDialoge: false };

    }
    private cloeseDialoge = () => {
        this.setState({ showDialoge: false });
    }
    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post("WindowsClient/SaveMobileUserSettings", this.props.entity)
                .then(result => {
                    this.textBoxValue = result.Message;
                    this.setState({ showDialoge: true });
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                });
        }
        else {
            return null;
        }
    }

    generateNewNukreis = (closeAfterSave) => {
        HTTPService.post("WindowsClient/GenerateNewNukreis", this.props.entity)
            .then(result => {
                this.textBoxValue = result.Message;
                this.setState({ showDialoge: true });
                this.common.handlePostSave(result.Code === 0, closeAfterSave);
            });

    }
    private createDialog = () => {
        let textBoxProps = this.factory.getDefaultTextBoxProps();
        textBoxProps.value = this.textBoxValue;
        textBoxProps.field.multiLine = true;

        return (
            <Dialog title={""}
                width="800px"
                actions={this.dialogActions}
                open={this.state.showDialoge}
                afterClose={() => { this.setState({ ...this.setState, showDialoge: false }) }}
            >
                <TextBox {...textBoxProps} />
            </Dialog>
        );
    }
    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const dialoge = this.state.showDialoge ? this.createDialog() : null;
        return <>
            {dialoge}
            <CommonApp {...props} />
        </>;
    }

}
interface EditMobileUserSettingsState {
    showDialoge: boolean;
}
interface EditMobileUserSettingsProps extends AppBaseProps {
    entity: any;
}